import React, { useState } from 'react';

// componenets
import { default as IRViewerInfo } from './ImageInfo';
import { default as IRViewerMarkerInfo } from './MarkerInfo';
import { default as NotesContainerComponent } from './Notes';

// enums
import secondaryNavTabsEnum from '../../../../enums/secondaryNavTabsEnum';

import { Tab, Tabs } from '@common-ui/ui';

function PanelImageInfo({ imageData = {}, settings = {}, photonotes = [], onChange = null }) {
  const {
    MARKERS = {},
    EditorNotes = [],
    referenceMarkerId = '',
    temperatureUnit = 'C',
  } = settings;

  const { DATA: { json: imageInfo = {} } = {} } = imageData || {};

  const [currentTab, setCurrentTab] = useState(secondaryNavTabsEnum.INFO);
  const navTabs = Object.keys(secondaryNavTabsEnum).filter((navTab) => navTab !== 'BATCHEDIT');

  const styles = {
    tabContainer: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };

  return (
    <div style={styles.tabContainer}>
      <Tabs activekey={currentTab} value={currentTab}>
        {navTabs.map((navTab, index) => (
          <Tab
            key={index}
            role="tabpanel"
            label={secondaryNavTabsEnum[navTab]}
            onClick={() => setCurrentTab(secondaryNavTabsEnum[navTab])}
            value={secondaryNavTabsEnum[navTab]}
          />
        ))}
      </Tabs>

      <div style={{ width: '100%' }}>
        <div
          style={{
            display: currentTab === secondaryNavTabsEnum.INFO ? 'block' : 'none',
          }}
        >
          <IRViewerInfo imageInfo={imageInfo} temperatureUnit={temperatureUnit} />
        </div>
        <div
          style={{
            display: currentTab === secondaryNavTabsEnum.MARKERS ? 'block' : 'none',
          }}
        >
          <IRViewerMarkerInfo
            markers={MARKERS}
            referenceMarkerId={referenceMarkerId}
            onChange={onChange}
            temperatureUnit={temperatureUnit}
          />
        </div>
        <div
          style={{
            display: currentTab === secondaryNavTabsEnum.NOTES ? 'block' : 'none',
          }}
        >
          <NotesContainerComponent
            notes={EditorNotes}
            photonotes={photonotes}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
}

const arePropsEqual = (prevProps, nextProps) => {
  const prevJson = prevProps.imageData?.DATA?.json;
  const nextJson = nextProps.imageData?.DATA?.json;

  if (prevJson !== nextJson) {
    return false;
  }

  if (prevProps.photonotes !== nextProps.photonotes || prevProps.onChange !== nextProps.onChange) {
    return false;
  }

  if (!prevProps.settings || !nextProps.settings) {
    return false;
  }

  const prevSettings = prevProps.settings;
  const nextSettings = nextProps.settings;

  const keysToCheck = ['MARKERS', 'referenceMarkerId', 'EditorNotes', 'temperatureUnit'];

  for (const key of keysToCheck) {
    if (prevSettings[key] !== nextSettings[key]) {
      // Change detected, return false to trigger rerender
      return false;
    }
  }

  return true;
};

export default React.memo(PanelImageInfo, arePropsEqual);
